import {Component, OnInit, ElementRef, ViewChild} from '@angular/core';
import { ModalController, NavController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { EsriObjectData } from '../../providers/esri-object-data';
import { AppData } from '../../providers/app-data';
import { IdentifyData } from '../../providers/identify-data';
import { MapData } from '../../providers/map-data';
import { SearchData } from '../../providers/search-data';
import { ToastData } from '../../providers/toast-data';

import { DisclaimerPage } from '../disclaimer/disclaimer';
import { OptionsPage } from '../options/options';
import { LocationList } from '../location-list/location-list.component'
import { IdentifyPage } from '../identify/identify';
import 'rxjs/add/observable/of';
import { SearchResult, XandY, TMSSite, FeatureLayerDefinition } from '../../interfaces';

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})

export class HomePage implements OnInit {

    @ViewChild('map') mapEl: ElementRef;
    searchText: string;
    private appSettings:any;
    public myData: any;
	public mySource: any;
    public results: Array<any> = [];
    public userString: string;
    public showEmail = false;

    constructor(public navCtrl: NavController, public modalCtrl: ModalController, private appData: AppData,
        private esriObjectData: EsriObjectData, private identifyData: IdentifyData, private mapData: MapData, 
        private searchData: SearchData, private toastData: ToastData
        ) {
            this.appSettings = appData.settings;
    }

    async ngOnInit() {
        if (!this.appData.acceptedDisclaimer) {
             let disclaimerPage =this.modalCtrl.create(DisclaimerPage, {},  { enableBackdropDismiss: false} );
             disclaimerPage.present();
        }

        await this.mapData.initializeMap(this.mapEl.nativeElement);

        this.identifyData.identifyComponent = IdentifyPage;
        window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
            this.toastData.presentMessage(errorMsg);
        }
    }

    ngAfterViewInit() {
        let inputField: HTMLElement = <HTMLElement>document.querySelectorAll('.search input')[0];
        if (inputField) {
            inputField.addEventListener('click', (event) => {
                this.showSearchInput();
            });
        }
    }

    showSearchInput() {
        this.searchData.searchMode = true;
    }

    hideSearch() {
        this.myData = null;
        this.searchData.searchMode = false;
    }

	centerMap() {
		this.mapData.zoomToCurrentLocation();
	}

    presentFilter() {
        this.identifyData.dismissModal();
        let modal = this.modalCtrl.create(OptionsPage, {});
        modal.present();
        modal.onWillDismiss((data: any[]) => {
            if (data) {
            }
        });
    }

    presentLocationList() {
        let modal = this.modalCtrl.create(LocationList, {});
        modal.present();
        modal.onWillDismiss((data: any[]) => {
            return;
        })
    }

    observableSource (keyword:any): Observable<any[]> {
		return this.searchData.getObservableSource(keyword);
	}

	autocompleListFormatter = (data: any) => {
		return "";
	}

	zoomToCurrentLocation() {
		this.mapData.zoomToCurrentLocation();
		this.hideSearch();
	}

	zoomToSelectedResult(selectedResult: SearchResult) {
        this.hideSearch();
        // we create a new feature layer for the HPMS Sample Search functionality
        // for any new searches, previously created feature layer is no longer needed.
        // Find the layer based on defintion expression and then delete it from map layers.
        let layerExits = this.mapData.EsriMap.layers.items.find(x => (x.definitionExpression !== undefined && x.definitionExpression.substr(0, 17) === 'HPMS_SAMP_SECT_NO'));
        if (layerExits !== undefined){
            this.mapData.EsriMap.remove(layerExits);
            let index = this.appData.CombinedFeatureLayers.findIndex(x => x.id === layerExits.id);
            this.appData.CombinedFeatureLayers.splice(index, 1);
        }

        if (selectedResult.county) {
            this.zoomToPointForSelectedSearchResult(selectedResult.county.long, selectedResult.county.lat);
        }
        else if (selectedResult.permanentSiteNo) {
            this.searchData.getTmsSiteByPermanentSiteNumber(selectedResult.permanentSiteNo).subscribe((tmsSite: TMSSite) => {
                this.zoomToTmsSite("Permanent Site", selectedResult.permanentSiteNo, tmsSite);
            });
        }
        else if (selectedResult.tmsSiteNo) {
            this.searchData.getTmsSite(selectedResult.tmsSiteNo).subscribe((tmsSite: TMSSite) => {
                this.zoomToTmsSite("TMS Site", selectedResult.tmsSiteNo, tmsSite);
            });
        }
        else if (selectedResult.hpmsSampleNumber){
            this.searchData.getHPMSSampleRecordByNumber(selectedResult.hpmsSampleNumber).subscribe((result: any) =>{
                this.zoomToHPMSSample(result.hpmsSampleNo, result.longitude, result.latitude);
            });
        } else {
			this.searchData.getLocationForPlace(selectedResult).subscribe( (r) => {
				let mercatorCoords : XandY = (<any>r).geometry;
				let point = this.esriObjectData.getMercatorPoint(mercatorCoords.x, mercatorCoords.y);
				this.mapData.showSearchLocationOnMap(point);				
			});
		}
    }

    zoomToTmsSite(numberType: string, searchNumber: number, tmsSite: TMSSite) {
        if (tmsSite) {            
            this.zoomToPointForSelectedSearchResult(tmsSite.primaryStation.longitude, tmsSite.primaryStation.latitude);            
        }
        else {
            this.toastData.presentMessage(numberType + " " + searchNumber + " not found.");
        }
    }
    zoomToHPMSSample(HpmsSampleNo: string, longitude: number, latitude: number){
        // add new HPMS Layer regardless of whether HPMS Road Layer is selected or not.
        // filter out duplicate feature during identify - see identify-data.ts : setSelectedFeaturesFromHitResults function.
        let featureLayerDefintion: FeatureLayerDefinition = {
            definitionExpression: "HPMS_SAMP_SECT_NO = '" + HpmsSampleNo + "'",
            geometryType: 'polyline',
            title: 'HPMS Sample',
            mapServerUrl: 'https://pddvgisweb.penndot.pa.gov/arcgis/rest/services/tds/tire/MapServer/',
            layerNumber: 1,
            fieldsAndAliases: ['CTY_CODE|County', 'ST_RT_NO|Route', 'HPMS_SAMP_SECT_NO|Sample ID', 'SEG_BGN|Segment Begin', 'OFFSET_BGN|Offset Begin', 'SEG_END|Segment End', 'OFFSET_END|Offset End', 'SEG_LNGTH_FEET|Length'],
            visible: true,
            renderer: {
                type: 'simple',            
                symbol: {
                    type: 'simple-line',
                    color: [0, 150, 0, 0.8],
                    style: 'solid',
                    width: 4
                }
            }
        }
        
        let featureLayer = new this.esriObjectData.EsriObjects.FeatureLayer({
            url: featureLayerDefintion.mapServerUrl + featureLayerDefintion.layerNumber,
            definitionExpression: featureLayerDefintion.definitionExpression,
            outFields: this.appData.getOutFieldsFromLayerDefinition(featureLayerDefintion),
            geometryType: featureLayerDefintion.geometryType,
            title: featureLayerDefintion.title,
            renderer: featureLayerDefintion.renderer,
            visible: featureLayerDefintion.visible
        });
        // add it to the map.
        // add it to the index after the initial feature layers so that the graphics layer can be seen when identifying the layer.
        this.mapData.EsriMap.add(featureLayer, this.appData.CombinedFeatureLayers.length);
        featureLayerDefintion.id = featureLayer.id;
        // add to identify layers
        this.appData.CombinedFeatureLayers.push(featureLayerDefintion);
    
        // zoom to calulated average Lat/Long. force zoom to 15.
        let point = this.esriObjectData.getGeographicPoint(longitude, latitude);
        this.mapData.zoomMapToPoint(point, 15, true);
    }
    zoomToPointForSelectedSearchResult(longitude: number, latitude: number) {
        let point = this.esriObjectData.getGeographicPoint(longitude, latitude);
        this.mapData.showSearchLocationOnMap(point);
    }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts